import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import get from 'lodash.get';

export default (props) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1132.93 839.14"
      {...props}
    >
      <defs>
        <linearGradient
          id="a"
          x1="819.93"
          x2="819.93"
          y1="598.64"
          y2="132.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor="gray"
            stopOpacity="0.25"
          />
          <stop
            offset="0.54"
            stopColor="gray"
            stopOpacity="0.12"
          />
          <stop
            offset="1"
            stopColor="gray"
            stopOpacity="0.1"
          />
        </linearGradient>
        <linearGradient
          id="b"
          x1="855.68"
          x2="855.68"
          y1="218.69"
          y2="216.24"
          xlinkHref="#a"
        />
        <linearGradient
          id="c"
          x1="476.17"
          x2="476.17"
          y1="658.02"
          y2="395.19"
          gradientTransform="rotate(90 629.01 560.64)"
          xlinkHref="#a"
        />
        <linearGradient
          id="d"
          x1="476.5"
          x2="476.5"
          y1="725.77"
          y2="463.92"
          gradientTransform="rotate(90 643.61 568.06)"
          xlinkHref="#a"
        />
        <linearGradient
          id="e"
          x1="456.74"
          x2="456.74"
          y1="719.17"
          y2="457.32"
          gradientTransform="rotate(90 617.54 562.87)"
          xlinkHref="#a"
        />
        <linearGradient
          id="f"
          x1="450.43"
          x2="450.43"
          y1="726.27"
          y2="464.42"
          gradientTransform="translate(123.74 -187.29)"
          xlinkHref="#a"
        />
        <linearGradient
          id="g"
          x1="1003.59"
          x2="1003.59"
          y1="245.51"
          y2="74.84"
          gradientTransform="rotate(90 999.905 155.125)"
          xlinkHref="#a"
        />
        <linearGradient
          id="h"
          x1="864.79"
          x2="864.79"
          y1="849.53"
          y2="427.42"
          xlinkHref="#a"
        />
      </defs>
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M514.88 86.76C477.71 71.65 438.43 59 398.33 60.61c-59 2.32-115.51 37.78-143.27 89.85-23.52 44.11-26.42 95.82-36.55 144.77-12.48 60.32-36.38 117.64-61.92 173.7-13.72 30.07-28.19 60.87-30.44 93.88-3.13 45.82 18.78 91.49 53.13 122s80 46.56 125.77 50.07c24.37 1.87 49.83.14 71.48-11.2 22.9-12 39.59-33.69 62.58-45.51 21.31-11 46.23-12.5 70.15-11.07a314.14 314.14 0 0191.59 19.46c33.43 12.56 64.52 30.74 97.88 43.47s70.63 19.84 104.73 9.21c32-10 57.34-34.2 80.17-58.75a1028.14 1028.14 0 00102.2-129.3c20.59-30.84 39.75-63.38 48.86-99.33 17.4-68.72-6.55-146.26-59.69-193.2-44-38.88-103.09-55.76-160.92-66-52.73-9.34-113.7-9.92-162.24-34.26-46.3-23.25-88.42-51.9-136.96-71.64z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="url(#a)"
        d="M904.73 150.7c-14.28.57-15 37.44-14.11 39.05S887.38 208 887.38 208s-6.48 25.23-5.73 29.92-3.49 7.76-3.49 7.76c-6.34 2.5-14.29 10.56-16.4 12.77l-.53.57s-6.14 4-7.22 5.58-4 .32-4 .32-8.3-.8-9.38-.48c-.74.22-1.9-1.14-2.56-2-.31-.41-.51-.72-.51-.72l-.25-7.44a6.09 6.09 0 00-1-.62c.17-.84.38-1.71.64-2.6a22.28 22.28 0 009.09-8.16c.24-.38.46-.77.67-1.16a3 3 0 001.89.53 3.75 3.75 0 00.88-.08 7.11 7.11 0 002.56-1.29 13.7 13.7 0 004.76-5.58 9.05 9.05 0 00.45-1.33c-.15.25-.31.5-.47.74a7.69 7.69 0 00-.53-6.49c-.78-1.26-2-2.28-2.5-3.68-.84-2.41.75-4.9 1.73-7.26a12.21 12.21 0 00.89-6.84 8.74 8.74 0 00-3.7-5.77c-3.93-2.55-9.26-1.15-13.81-2.38a37.39 37.39 0 01-4.75-1.91 36 36 0 00-7.27-2.26c-2.47-.49-5.46-.54-7 1.39a14.38 14.38 0 00-1.14 1.93 7.15 7.15 0 01-4.47 3.21 16.76 16.76 0 01-2.75.29 2.66 2.66 0 000-1.14c-1.16-3.8 2.16-6.62 6.48-8.32s20.75-14.64 22.66-17.71 15.28-12.7 15.28-12.7 20-5.66 26.56-26.28-31.38 14.4-35.2 15.45-9.29 5-9.29 5l-24.33 14.07a88.12 88.12 0 00-13.12 9.06c-5.89 5.09-9.62 13.74-9.62 13.74s-2.33 3.8-5.73 9.3a25.32 25.32 0 01-7.42 7.89l.11-.2c-.27.33-8.64 10.9-9.38 15.52s-4.15 23.45-4.15 23.45-3 14.79-5.06 17.7c0 0-1.67 8.49-2.66 9.63s-5 13.17-4.32 14.39c0 0-3.82 8.33-3.15 11.48l-6.89 16.5s-3.74 8.16-3.49 12.93c.12 2.31.22 5 .29 7.2v2c-.37.62-1.32 2.2-2.31 4.11-1.42 2.78-2.93 6.25-2.84 8.39.16 3.76.17 12.94-1.56 16.31l-.51-.2a7 7 0 00-1 3.32l.12.06c0 .29-.09.59-.12.91-.42 3.83.19 9.16-.77 10.33-1.33 1.62-.67 37.52-.67 37.52s-2.16 22.47 2.16 36.71l-.33 11.15s-.17 10.51.33 12 .67 12.13.67 12.13l2.49 17.79s-3.33 27.49-.5 34.28a37.36 37.36 0 013 11.81 18.37 18.37 0 004.58 1.77v1l-.65 16.72v.92s-.08.44-.14 1.17v.41a.49.49 0 000 .12v.35a2.44 2.44 0 000 .27 1.93 1.93 0 010 .24V586.48c0 .17.05.33.08.5a.5.5 0 000 .12c0 .19.07.37.11.55 0 .18.08.36.13.54a.13.13 0 010 .06c0 .09.05.19.08.28a.5.5 0 000 .13c0 .11.07.22.1.34v.08c.1.28.2.56.32.84a.36.36 0 000 .09c0 .1.09.21.14.31l.06.14.13.27.08.15.14.25.09.15c0 .08.09.16.14.24s.07.1.1.16l.15.23.11.15.16.23.12.15.18.22.12.14.21.24.11.12.34.33a.52.52 0 00.11.1 2.73 2.73 0 00.25.23l.16.13.22.18.19.14.22.16.21.14.22.14.23.13.23.14.24.12.25.12.25.12.25.11.27.11.27.1.28.1.3.09.47.14.39.1.31.06.32.07h.34l.33.05H754.73l.54-.05h.33l.91-.1s11.33 1.69 11.7-2.79c0-.23 0-.47.05-.72v-.57a1.48 1.48 0 010-.21V591.02v-1.3-1.34-.5V586.45v-.31c-.07-2.22-.18-4.28-.25-5.43 0-.61-.06-1-.06-1s-3.86-5.82-3.23-8 .49-9.58.49-9.58-1.5-3.55-2.51-6.69c-.08-.24-.15-.48-.22-.71a36.92 36.92 0 002.36-3 38 38 0 00-2.82-22.8 1.42 1.42 0 01-.61-1.17.49.49 0 010-.12l1.93-23.61-1.17-13.74s-.83-9.39 1-13.43l3.65-35.57L772 420.6s1.66-.81 3 3.08 4.64 21.5 4.64 21.5l8 29.11s1.33 10.35 2.49 11.81 1.17 7.92 1.17 7.92 2.49 5.18 2.16 7.44 0 8.41.82 10.51 1.17 17 1.17 17a34.34 34.34 0 00.33 14.72c2 7.44.83 16.82.83 16.82a11.48 11.48 0 00.68.94c-.08.22-.17.44-.25.64-.52 1.35-.93 2.3-.93 2.3s-.12 7.4.5 9.58-3.24 8-3.24 8 0 .36-.06 1c-.07 1.15-.18 3.2-.25 5.43V594.1a1.28 1.28 0 000 .19v.58c0 .19 0 .49.05.72.38 4.48 11.71 2.79 11.71 2.79l.91.11H810.79l.34-.06.33-.05.32-.07.32-.06.39-.1.47-.14.29-.09.28-.1a2.15 2.15 0 00.27-.1l.27-.11.26-.11.25-.11.25-.13.23-.12.24-.13.22-.14.23-.14.2-.14.22-.16a1.33 1.33 0 00.19-.14 1.84 1.84 0 00.22-.17l.17-.14.25-.22.11-.11.34-.33.1-.12.22-.23.11-.15a2 2 0 00.19-.22l.11-.15.17-.23.1-.15.16-.23a1.4 1.4 0 01.1-.16c0-.08.09-.16.14-.24l.09-.15c0-.09.09-.17.13-.25a1.09 1.09 0 00.08-.15c0-.09.09-.18.13-.27l.07-.14c0-.1.09-.2.14-.31v-.09c.11-.28.22-.56.31-.84v-.08c0-.11.07-.22.11-.33a.74.74 0 010-.14c0-.09 0-.19.08-.28v-.05a.13.13 0 000-.06c0-.18.1-.36.14-.53 0-.18.08-.36.11-.54v-.13c0-.17.06-.33.08-.49s0-.11 0-.17v-.33-.25-.16-.56-1.75a2.44 2.44 0 010-.27v-.35a.49.49 0 010-.12v-.4c-.06-.73-.13-1.17-.13-1.17v-.91l-.63-16.18v-1c.93-.52 1.88-1.11 2.87-1.8 0 0-.17-9.22 2.49-12.93s-1.33-13.43-1.33-13.43l-1.66-34.77.66-16a15.91 15.91 0 01-2-7.76 28.23 28.23 0 00-2.66-10s-1.66-5.5.34-7.12-2.16-37-2.16-37 1-25.85-.9-41.2v-.25l.53-.24c-.16-1.23-.33-2.38-.52-3.45l-.56.17a28.1 28.1 0 00-1-4L811 363s-.06-.64-.13-1.57c-.09-1.1-.19-2.59-.21-3.9a6.63 6.63 0 01.18-1.64l-.14-.12a3.63 3.63 0 01.14-.85l-.58-.49s-.08-.55-.14-1.39c-.13-1.86-.2-5.1.72-6.93 1.33-2.67 15-12.78 15-12.78L833.5 318s7.64-10.76 13.45-12.86S870.86 291 870.86 291s6.31-6.47 6.81-8l.21-.32h.12v-.21L895 257c6.8-5.5 7.05-17.22 7.05-17.22l1.77-26.78-.58-15.84.82-9s14.94-38.02.67-37.46zM807.35 220a21.43 21.43 0 00-2.82 10.62v.97a21.36 21.36 0 002.27 9.58 7.85 7.85 0 00-1.65 2.93c-.84-1.06-3.3-4.3-3.44-6.45-.17-2.58-2.66-4.36-2.66-4.36s-.46-4.9.16-5.74l.09-.08s.07-.12.21-.32c.71-1.07 3.1-4.68 5.57-8.79a7.87 7.87 0 001.27.42l1.52.38z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="url(#b)"
        d="M855.79 217.3c.15-.34.27-.7.39-1.06a22.12 22.12 0 00-1 2.45c.21-.47.42-.93.61-1.39z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f6bac2"
        d="M811.79 241.08s-3.13 14.92-8.9 16.85 7 19 7 19l26.47-1.45.48-5.53s-5-11.07 3.37-24.54-28.42-4.33-28.42-4.33z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#b77983"
        d="M770.28 593.35c-.36 4.45-11.31 2.77-11.31 2.77-18.16 2.52-15.16-15.28-15.16-15.28v-.91l.63-16.6.18-4.63s20-9.14 19.49-7.22c-.19.72.23 2.45.81 4.32 1 3.11 2.43 6.63 2.43 6.63s.12 7.34-.48 9.5 3.13 7.94 3.13 7.94 0 .36.06 1a116.68 116.68 0 01.22 12.48zM805.29 598.16s-10.95 1.69-11.31-2.77a113.72 113.72 0 01.19-12.51c0-.6.05-1 .05-1s3.73-5.78 3.13-7.94-.48-9.51-.48-9.51.39-.93.9-2.27c1.07-2.81 2.68-7.37 2.35-8.67-.48-1.93 19.49 7.21 19.49 7.21l.2 5.18.61 16.05v.91s3.04 17.85-15.13 15.32z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f6bac2"
        d="M880.36 142.35c-6.36 20.45-25.66 26.07-25.66 26.07S841.78 178 839.94 181s-17.72 15.88-21.9 17.57-7.37 4.49-6.25 8.25c1 3.49-9.94 20.57-11.59 23.11l-.2.32-3.45 3.61-11.71 5.93-9.54-3.05-1.21-11.46 5.06-9a24.83 24.83 0 007.17-7.83c3.29-5.46 5.54-9.22 5.54-9.22s3.61-8.58 9.3-13.64a84.15 84.15 0 0112.67-9l23.51-14s5.29-3.93 9-5 40.36-35.69 34.02-15.24z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M784.84 232.42l15.64-3.13a1 1 0 00-.28.65l-.2.32-3.45 3.61-11.71 5.93-9.54-3.05-1.21-11.46 5.06-9c-4.79 10-.12 17.1-.12 17.1zM876.3 284.08a2.92 2.92 0 00-.11.32 4.39 4.39 0 01-.58 1l-6.31 3.08-9.63 1-5-12.11L858 264.1l1.84-2.48.51-.56c.19 2.4 1.16 14.92 1.1 18.68-.08 4.17 3 4.5 3 4.5z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#d39999"
        d="M875.82 285a2.92 2.92 0 00-.11.32c-.48 1.52-6.57 7.94-6.57 7.94s-17.49 11.95-23.1 14-13 12.75-13 12.75l-7.38 15.23s-13.23 10-14.51 12.68c-.89 1.82-.82 5-.69 6.88 0 .83.12 1.38.12 1.38l-3.9 4.07-3.11 3.24-4.38 4.56-7.13-1-22.22-3.53-4.26-2.4-23.65-13.32s0-.83-.06-2.1c0-.56 0-1.2-.06-1.91-.07-2.16-.17-4.85-.28-7.14-.24-4.73 3.37-12.83 3.37-12.83l6.65-16.37c-.64-3.12 3.05-11.39 3.05-11.39-.64-1.2 3.21-13.15 4.17-14.27s2.57-9.55 2.57-9.55c2-2.88 4.89-17.56 4.89-17.56s3.29-18.61 4-23.26 8.8-15.07 9.06-15.39c-5.77 10.58-.72 18.28-.72 18.28l5.78-1 15.65-3.05c-.72.48-.24 5.77-.24 5.77a6.67 6.67 0 012.56 4.33c.15 2.35 3 6 3.53 6.65l.08.09a7.83 7.83 0 013.77-5.38l3.61 4.82 1.21 5.77s-.33.81-2.41 2.41.88 5.77.88 5.77c1 1.69 1.29 7.94 1.29 7.94 2.65-2.32 6.81-2.32 6.81-2.32a20.62 20.62 0 004.09-5.86 2.42 2.42 0 013.45-1.6 22.18 22.18 0 013.93-2.73c1.93-1 4.17 1 4.17 1l.24 7.39s.19.3.5.71c.63.88 1.76 2.23 2.47 2 1-.32 9.06.48 9.06.48s2.81 1.2 3.85-.32 7-5.53 7-5.53S861 276.54 861 280.7s3 4.5 3 4.5z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        d="M876 285h-.21c.38-1 .21 0 .21 0z"
        transform="translate(-33.54 -30.43)"
      />
      <circle
        cx="776.65"
        cy="244.82"
        r="1.44"
        fill="#4b4442"
      />
      <circle
        cx="766.14"
        cy="265.76"
        r="1.44"
        fill="#4b4442"
      />
      <circle
        cx="745.45"
        cy="310.59"
        r="1.44"
        fill="#4b4442"
      />
      <circle
        cx="755.23"
        cy="287.97"
        r="1.44"
        fill="#4b4442"
      />
      <path
        d="M765 555.8c-7.52 8.94-15.64 8.79-20.48 7.53l.18-4.63s20-9.14 19.49-7.22c-.19.72.19 2.45.81 4.32zM819.81 565.92c-12.77 7.38-20.26-1.27-22-3.72 1.07-2.81 2.68-7.37 2.35-8.67-.48-1.93 19.49 7.21 19.49 7.21z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#8499f0"
        d="M824.94 550.36c-2.56 3.69-2.41 12.83-2.41 12.83-16.52 11.87-25.18-2.57-25.18-2.57s1.12-9.3-.8-16.68a34.81 34.81 0 01-.32-14.6s-.32-14.76-1.13-16.84-1.12-8.18-.8-10.43-2.08-7.37-2.08-7.37 0-6.42-1.13-7.86-2.4-11.72-2.4-11.72L781 446.25s-3.21-17.48-4.49-21.33-2.89-3.05-2.89-3.05L769 442.56l-3.53 35.29c-1.77 4-1 13.32-1 13.32l1.12 13.63-1.86 23.42a.49.49 0 000 .12 1.43 1.43 0 00.58 1.16 38.54 38.54 0 012.69 22.62c-12.19 17.65-26.95 8.5-26.95 8.5a37.43 37.43 0 00-2.88-11.7c-2.73-6.74.48-34 .48-34l-2.41-17.65s-.16-10.59-.64-12-.32-11.87-.32-11.87l.32-11.07c-4.17-14.12-2.09-36.41-2.09-36.41s-.64-35.61.65-37.22c.93-1.16.34-6.44.74-10.25a7.15 7.15 0 01.94-3.29l.16-.16c2.09-2.57 2.09-12.83 1.92-16.85-.08-2.12 1.37-5.56 2.75-8.32 1-1.94 1.91-3.54 2.25-4.12l.14-.23s9.14 2.25 33.36 13.8a45.52 45.52 0 0013.78 4.27 30.66 30.66 0 007.19.11 25.1 25.1 0 0010.34-3.36 18.18 18.18 0 004.47-3.59c-.33 1-.13 4.42 0 6.46.06.93.13 1.56.13 1.56l2.67 11.9a31.21 31.21 0 011 4.31c.19 1.06.35 2.21.5 3.43 1.87 15.22.87 40.87.87 40.87s4 35.13 2.09 36.73-.33 7.06-.33 7.06a28.47 28.47 0 012.57 9.94 16 16 0 001.93 7.7l-.65 15.88 1.68 34.45s3.85 9.67 1.28 13.36z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M806.13 492.29s12.15-7 14.8-3.85-14.8 3.85-14.8 3.85zM813.47 496.14s-2 1 2.41 2.28-2.41-2.28-2.41-2.28zM740 476.89c-.41.12 10.11 7.1 19.61 1.32-.04 0-17.24-2.04-19.61-1.32zM759.09 490.24s-2.88 5.66-8.78 6.5 8.78-6.5 8.78-6.5zM797.71 502.52s13.84 22 11.19 27.19-11.19-27.19-11.19-27.19zM774.37 369.09l-1.44 43.07s8.54-.36 10-14.55 2.53-25.75 2.53-25.75z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#8499f0"
        d="M773.89 368.13l-1.44 43.07s8.54-.36 10-14.56S785 370.9 785 370.9z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M756.57 370.06s-6.74 18.07-22.16 9.32a7.11 7.11 0 01.94-3.29c4.22 1.77 14 4.36 18-7.36z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M756.09 368.13s-6.74 18.07-22.16 9.32a7.15 7.15 0 01.94-3.29c4.22 1.78 14 4.36 18-7.35z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#8499f0"
        d="M756.09 369.09s-6.74 18.07-22.16 9.32a7.15 7.15 0 01.94-3.29c4.22 1.78 14 4.36 18-7.35z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M815.09 385.33c-16.94 8.06-23.15-10.94-23.15-10.94l4 .12c.7 12.15 14.09 8.88 18.68 7.39.16 1.1.32 2.21.47 3.43z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M816.05 383.89c-16.93 8.05-23.15-10.95-23.15-10.95l4 .12c.7 12.15 14.09 8.89 18.68 7.4.16 1.06.32 2.21.47 3.43z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#8499f0"
        d="M815.57 384.37c-16.93 8.05-23.15-10.95-23.15-10.95l4 .12c.7 12.16 14.09 8.89 18.68 7.4.16 1.06.32 2.21.47 3.43z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#fff"
        d="M756.09 369.09s-6.74 18.07-22.16 9.32a7.15 7.15 0 01.94-3.29c4.22 1.78 14 4.36 18-7.35zM815.57 384.37c-16.93 8.05-23.15-10.95-23.15-10.95l4 .12c.7 12.16 14.09 8.89 18.68 7.4.16 1.06.32 2.21.47 3.43z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M770.4 590c0 1.23 0 2.38-.12 3.33-.36 4.45-11.31 2.77-11.31 2.77-10 1.39-13.6-3.41-14.79-8a18.31 18.31 0 01-.55-4.56 18.91 18.91 0 01.18-2.74v-.91a6.69 6.69 0 016.22 1.27c4.45 3.61 10.35.84 10.35.84s4.33.36 6 1.8c.94.81 2.49-1.14 3.67-3 .07 1.2.18 3.37.25 5.69.08 1.19.1 2.39.1 3.51z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M752.84 589.74s-3 2.94-8.66-1.6a18.31 18.31 0 01-.55-4.56c2.89 2.2 8.25 6.16 9.21 6.16zM770.4 590a2.26 2.26 0 01-3.25-.52 21.39 21.39 0 003.2-3c.03 1.2.05 2.4.05 3.52zM793.87 592.06c0 1.24 0 2.39.11 3.33.36 4.46 11.31 2.77 11.31 2.77 10 1.4 13.6-3.4 14.79-8a19.21 19.21 0 00.37-7.3v-.91a6.77 6.77 0 00-6.23 1.27c-4.45 3.61-10.34.84-10.34.84s-4.33.37-6 1.81c-.94.81-2.49-1.14-3.66-3-.07 1.2-.19 3.37-.26 5.69-.08 1.17-.1 2.37-.09 3.5z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M811.43 591.78s3 2.94 8.65-1.6a18.24 18.24 0 00.56-4.55c-2.9 2.19-8.26 6.15-9.21 6.15zM793.87 592.06a2.25 2.25 0 003.24-.52 21.15 21.15 0 01-3.2-3c-.03 1.19-.05 2.39-.04 3.52zM780.67 285s-15.4 42.51-9.47 46.2 9.47-46.2 9.47-46.2zM791.9 271.88s-2.9 14.12-1.45 15.4 1.45-15.4 1.45-15.4zM823 304.77s-18.93 17.64-17.65 19.09S823 304.77 823 304.77zM837.47 265.94c-7.17 2.19-23.93 7.31-24.12 7.27l.93-3.82c2.65-2.32 6.81-2.32 6.81-2.32a20.62 20.62 0 004.09-5.86 2.42 2.42 0 013.45-1.6 22.77 22.77 0 013.93-2.73c1.93-1 4.17 1 4.17 1l.24 7.38s.19.27.5.68z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#d39999"
        d="M837.47 265c-7.17 2.19-23.93 7.31-24.12 7.26l.93-3.81c2.65-2.32 6.81-2.32 6.81-2.32a20.62 20.62 0 004.09-5.86 2.42 2.42 0 013.45-1.6 22.18 22.18 0 013.93-2.73c1.93-1 4.17 1 4.17 1l.24 7.39s.19.24.5.67z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M812.51 261c1 1.69 1.28 7.94 1.28 7.94l-2.79 2.22-5.3-15.28-.24-7.94-.1-.45.08.09a7.79 7.79 0 013.77-5.37l3.61 4.81 1.21 5.77s-.33.81-2.41 2.41.89 5.8.89 5.8z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#d39999"
        d="M813 260.49c1 1.69 1.29 7.94 1.29 7.94l-2.79 2.25-5.3-15.28-.24-7.94-.11-.45.08.09a7.83 7.83 0 013.77-5.38l3.61 4.82 1.21 5.77s-.33.81-2.41 2.41.89 5.77.89 5.77z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M848.36 234.35a21.65 21.65 0 11-21.65-21.66 21.47 21.47 0 0121.65 21.66z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f6bac2"
        d="M848.36 233.38a21.66 21.66 0 11-21.65-21.65 21.53 21.53 0 0121.65 21.65z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M848.36 233.38a21.53 21.53 0 01-3.15 11.25c-.32-.57-.51-1.23-.83-1.81-.45-.81-1.49-1.49-2.26-1a2.31 2.31 0 00-.71 1c-.63 1.33-1.75 2.66-3.22 2.63a3.19 3.19 0 01-2.74-2.34 9.61 9.61 0 01-.16-3.82c.22-2.6.26-5.6-1.67-7.35a10.94 10.94 0 00-4.18-1.87c-1.47-.48-3-1.24-3.6-2.66-.4-1-.3-2.06-.66-3a5.25 5.25 0 00-3.89-2.86 10.2 10.2 0 01-6.81 2.33 25.52 25.52 0 01-6.7-1.06 21.66 21.66 0 0140.58 10.53z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#7e646b"
        d="M825.18 223.47c.36 1 .26 2.08.66 3 .59 1.42 2.13 2.18 3.6 2.66a11 11 0 014.18 1.86c1.93 1.76 1.89 4.76 1.67 7.36a9.61 9.61 0 00.16 3.82 3.21 3.21 0 002.74 2.34c1.47 0 2.59-1.3 3.22-2.63a2.33 2.33 0 01.71-1c.77-.51 1.81.17 2.26 1a9.91 9.91 0 001.29 2.43 2.88 2.88 0 002.63.6 6.63 6.63 0 002.47-1.28 13.54 13.54 0 004.6-5.53 7.94 7.94 0 00-.29-7c-.75-1.26-1.94-2.27-2.41-3.66-.82-2.39.72-4.85 1.67-7.19a12.48 12.48 0 00.85-6.79 8.72 8.72 0 00-3.57-5.73c-3.8-2.53-8.94-1.14-13.34-2.36a33.83 33.83 0 01-4.59-1.89 34 34 0 00-7-2.24c-2.39-.48-5.28-.54-6.79 1.37a15.14 15.14 0 00-1.1 1.92 6.91 6.91 0 01-4.32 3.18c-1.29.31-2.64.23-4 .42a4.4 4.4 0 00-3.33 1.91c-.66 1.2-.38 2.66-.22 4s.08 2.94-1 3.77c-.51.39-1.21.58-1.52 1.13a1.59 1.59 0 00.47 1.89 4.51 4.51 0 001.91.84 29.23 29.23 0 007.67 1.31 10.12 10.12 0 007.14-2.63c-.17.17-1.27.1-1.47.09 1.94.21 4.32 1.07 5.05 3.03z"
        transform="translate(-33.54 -30.43)"
      />
      <g opacity="0.05">
        <path
          d="M852 241.2a6.81 6.81 0 01-2.47 1.29 2.9 2.9 0 01-2.62-.61 9.76 9.76 0 01-1.3-2.43c-.45-.81-1.49-1.49-2.26-1a2.45 2.45 0 00-.71 1c-.62 1.33-1.75 2.66-3.22 2.63a3.17 3.17 0 01-2.73-2.34 9.61 9.61 0 01-.17-3.82c.23-2.6.26-5.59-1.66-7.35a11 11 0 00-4.19-1.87c-1.46-.48-3-1.24-3.6-2.66-.4-1-.3-2.06-.66-3-.59-1.59-2.26-2.46-3.89-2.86a10.38 10.38 0 01-6.81 2.34 29.66 29.66 0 01-7.67-1.32 4.63 4.63 0 01-1.91-.83 2.11 2.11 0 01-.31-.36 2.8 2.8 0 00-1.12.87 1.59 1.59 0 00.47 1.89 4.51 4.51 0 001.91.84 29.23 29.23 0 007.67 1.31 10.29 10.29 0 006.8-2.33c1.63.4 3.31 1.26 3.9 2.85.36 1 .26 2.08.66 3 .6 1.42 2.13 2.18 3.6 2.66a11 11 0 014.18 1.86c1.93 1.76 1.89 4.76 1.67 7.36a9.61 9.61 0 00.16 3.82 3.21 3.21 0 002.74 2.34c1.47 0 2.59-1.3 3.22-2.63a2.33 2.33 0 01.71-1c.77-.51 1.81.17 2.26 1a9.61 9.61 0 001.3 2.43 2.86 2.86 0 002.62.6 6.63 6.63 0 002.47-1.28 13.54 13.54 0 004.6-5.53 8.84 8.84 0 00.43-1.32 14.26 14.26 0 01-4.07 4.45zM854 221.58c.21-.46.41-.92.6-1.37s.26-.7.37-1.06a23.64 23.64 0 00-.97 2.43zM807.24 215.29c1-.85 1.07-2.37.91-3.68a16.35 16.35 0 01-.19-2.31 3.4 3.4 0 00-.55.7c-.66 1.2-.38 2.66-.22 4a7.79 7.79 0 01.05 1.29z"
          transform="translate(-33.54 -30.43)"
        />
      </g>
      <path
        d="M811.18 364.16c-1.86.13-4.47.27-7.61.38-2.18.07-4.62.12-7.23.12-2.28 0-4.69 0-7.19-.11a154.17 154.17 0 01-23.57-2.43c-10.39-2-20-5.45-26-11.29 1-1.94 1.91-3.55 2.25-4.12 0-.56 0-1.21-.06-1.91 10.55 5 43.44 18.89 68.65 11 0 .83.12 1.38.12 1.38l.57.48c-.29 1.04-.11 4.46.07 6.5z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#4b4442"
        d="M811.18 363.2c-1.86.13-4.47.27-7.61.37-2.18.08-4.62.12-7.23.12-2.28 0-4.69 0-7.19-.11a154.13 154.13 0 01-23.57-2.42c-10.39-2-20-5.46-26-11.3 1-1.94 1.91-3.54 2.25-4.12 0-.56 0-1.2-.06-1.91 10.55 5 43.44 18.9 68.65 11.05 0 .83.12 1.38.12 1.38l.57.48c-.29 1-.11 4.42.07 6.46z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#b7b6cc"
        d="M312.07 800.87A13.75 13.75 0 01309 790.4l44.14-361.17 3.66-30a13.85 13.85 0 0113.64-12.16l129.29-.86A13.83 13.83 0 00513.47 372l-.05-1.37a13.84 13.84 0 0113.83-14.31h135.86a13.83 13.83 0 0113.83 13.8 14.76 14.76 0 01-.12 1.86 13.83 13.83 0 0013.36 15.66l130.48 3.33a13.82 13.82 0 0113.28 16.16l-65.23 381-1.23 7.2a13.53 13.53 0 01-2 5.16z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="url(#c)"
        d="M531.63 367.62H794.46V447.98H531.63z"
        opacity="0.5"
        transform="rotate(-55.36 617.318 424.549)"
      />
      <path
        fill="#f9fafb"
        d="M625.39 278.52H701.79V537.8299999999999H625.39z"
        transform="rotate(34.64 695.572 339.139)"
      />
      <path
        fill="#f7b643"
        d="M692.62 300.18H746.63V354.19H692.62z"
        transform="rotate(35 749.585 254.464)"
      />
      <path
        fill="#f7b643"
        d="M655.56 353.83H709.5699999999999V407.84H655.56z"
        opacity="0.5"
        transform="rotate(34.64 714.542 311.795)"
      />
      <path
        fill="#f7b643"
        d="M618.49 407.48H672.5V461.49H618.49z"
        opacity="0.3"
        transform="rotate(34.64 677.472 365.437)"
      />
      <path
        fill="url(#d)"
        d="M485.89 360.77H747.74V441.13H485.89z"
        opacity="0.5"
        transform="rotate(-73.71 579.745 408.1)"
      />
      <path
        fill="#f9fafb"
        d="M579.25 271.97H655.65V530.3H579.25z"
        transform="rotate(16.29 706.988 268.762)"
      />
      <path
        fill="#f97878"
        d="M617.98 280.09H671.99V334.09999999999997H617.98z"
        transform="rotate(16.29 734.529 174.73)"
      />
      <path
        fill="#f97878"
        d="M599.69 342.68H653.7V396.69H599.69z"
        opacity="0.5"
        transform="rotate(16.29 716.248 237.312)"
      />
      <path
        fill="#f97878"
        d="M581.4 405.26H635.41V459.27H581.4z"
        opacity="0.3"
        transform="rotate(16.29 697.968 299.892)"
      />
      <path
        fill="url(#e)"
        d="M461.24 361.9H723.09V442.26H461.24z"
        opacity="0.5"
        transform="rotate(-85.4 558.942 405.02)"
      />
      <path
        fill="#f9fafb"
        d="M554.62 272.96H631.02V531.29H554.62z"
        transform="rotate(4.6 954.38 -30.975)"
      />
      <path
        fill="#73b53b"
        d="M573.68 277.45H627.6899999999999V331.46H573.68z"
        transform="rotate(4.6 962.182 -128.547)"
      />
      <path
        fill="#73b53b"
        d="M568.45 342.44H622.46V396.45H568.45z"
        opacity="0.5"
        transform="rotate(4.6 957.058 -63.627)"
      />
      <path
        fill="#73b53b"
        d="M563.23 407.44H617.24V461.45H563.23z"
        opacity="0.3"
        transform="rotate(4.6 951.81 1.298)"
      />
      <path
        fill="url(#f)"
        d="M533.99 277.13H614.35V538.98H533.99z"
        opacity="0.5"
        transform="rotate(-2.61 -111.13 1128.408)"
      />
      <path
        fill="#fff"
        d="M536.63 278.86H613.03V537.19H536.63z"
        transform="rotate(-2.61 -110.472 1128.423)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M543.37 283.13H597.38V337.14H543.37z"
        transform="rotate(-2.61 -115.05 1030.597)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M546.33 348.27H600.34V402.28H546.33z"
        opacity="0.5"
        transform="translate(-50.01 -3.96)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M549.3 413.4H603.31V467.40999999999997H549.3z"
        opacity="0.3"
        transform="rotate(-2.61 -109.012 1160.738)"
      />
      <path
        fill="#e6ecf8"
        d="M563.22 621.14l-67.88 26.26-99.21 38.35c-3.75-7-9.27-16.46-16.1-27.75-23.5-38.94-62.38-99.51-97-152.74-39-60-72.57-110.63-72.57-110.63l24.3-7L433.26 330z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M563.22 621.14l-67.88 26.26A510.2 510.2 0 01380 658c-23.5-38.94-62.38-99.51-97-152.74l-48.23-117.67L433.26 330z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M613.72 604.8s-105.45 62.38-262.89 48.27l-125.51-306 60.15-10.34 207.94-35.71 118 297.83z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M611.37 598.89c-24.83 1.22-53.56 1.1-82.46-2.35-31.28-3.68-62.74-11.26-89.71-25.16-22.55-11.61-41.83-24.24-58.64-39.39-43.73-39.33-70.79-95.59-95.09-195.22l207.94-35.71z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f9fafb"
        d="M688.73 581.78S611 597 531.88 587.63c-31.28-3.68-62.74-11.26-89.71-25.16-22.55-11.61-41.82-24.24-58.64-39.39-54.12-48.69-82.7-123.31-112.17-274 0 0 129.22 31.19 257-37.13-.04.05 43.03 268.83 160.37 369.83z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M531.88 587.63c-31.28-3.68-62.74-11.26-89.71-25.16-22.55-11.61-41.82-24.24-58.64-39.39 46.08-3.74 52.7-28.93 52.7-28.93 34.16 54.21 95.65 93.48 95.65 93.48z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M338.2 304.4s105.08-5.94 134.42-28.59l4.45 14.3s-69.43 30.63-138.87 31zM338.2 375s101.74-5.57 178.61-42.7l2.6 5.94s-61 35.61-181.21 44.93zM346.39 402.51s101.74-5.57 178.6-42.7l2.6 5.94s-61 35.6-181.2 44.93zM354.57 430.06s101.74-5.57 178.61-42.7l2.59 5.94s-61 35.61-181.2 44.93zM362.76 457.61s101.74-5.57 178.6-42.7l2.6 5.94s-61 35.61-181.2 44.93zM370.94 485.17s101.74-5.57 178.61-42.7l2.59 5.94s-61 35.6-181.2 44.93z"
        opacity="0.3"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1086.31 827.24s-42.28-2.55-37.3 27.08c0 0-1 5.23 3.76 7.61 0 0 .07-2.2 4.33-1.45a19.42 19.42 0 004.6.22 9.5 9.5 0 005.61-2.32s11.89-4.91 16.51-24.33c0 0 3.42-4.24 3.28-5.33l-7.13 3s2.44 5.15.52 9.42c0 0-.23-9.23-1.6-9-.28 0-3.71 1.78-3.71 1.78s4.19 9 1 15.48c0 0 1.2-11.05-2.34-14.83l-5 2.93s4.9 9.26 1.58 16.82c0 0 .85-11.59-2.64-16.11l-4.55 3.55s4.61 9.13 1.8 15.4c0 0-.37-13.5-2.79-14.52 0 0-4 3.51-4.58 5 0 0 3.15 6.62 1.19 10.12 0 0-1.2-9-2.18-9 0 0-4 6-4.38 10 0 0 .17-6.08 3.42-10.61a12 12 0 00-6.08 3.15s.62-4.22 7.06-4.58c0 0 3.28-4.52 4.15-4.8 0 0-6.4-.53-10.28 1.19 0 0 3.42-4 11.46-2.17l4.49-3.66s-8.43-1.16-12 .12c0 0 4.11-3.52 13.21-1l4.89-2.92s-7.18-1.55-11.46-1c0 0 4.51-2.44 12.9.2l3.49-1.57s-5.26-1-6.8-1.2-1.63-.58-1.63-.58a18.14 18.14 0 019.89 1.1s7.43-2.72 7.31-3.19z"
        transform="translate(-33.54 -30.43)"
      />
      <ellipse
        cx="1023.65"
        cy="834.08"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="29.92"
        ry="5.06"
      />
      <ellipse
        cx="813.75"
        cy="815.19"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="102"
        ry="9.24"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1106 729.43s-23.83-1.44-21 15.27a4.07 4.07 0 002.11 4.29s.05-1.24 2.45-.82a11.11 11.11 0 002.59.12 5.34 5.34 0 003.16-1.3s6.7-2.77 9.31-13.72c0 0 1.93-2.39 1.85-3l-4 1.71s1.37 2.91.29 5.32c0 0-.13-5.21-.9-5.09-.16 0-2.09 1-2.09 1s2.36 5 .58 8.73c0 0 .68-6.23-1.32-8.37l-2.83 1.66s2.76 5.22.89 9.48c0 0 .48-6.54-1.49-9.08l-2.56 2s2.59 5.15 1 8.68c0 0-.21-7.61-1.57-8.18a16 16 0 00-2.59 2.79s1.78 3.74.68 5.71c0 0-.68-5.07-1.23-5.09 0 0-2.24 3.35-2.47 5.65a12.24 12.24 0 011.93-6 6.7 6.7 0 00-3.43 1.78s.35-2.38 4-2.58c0 0 1.85-2.55 2.34-2.71 0 0-3.61-.3-5.8.67 0 0 1.93-2.24 6.46-1.22l2.54-2.07s-4.76-.65-6.77.07c0 0 2.32-2 7.45-.54l2.76-1.65a24.91 24.91 0 00-6.47-.55s2.55-1.38 7.27.11l2-.88s-3-.59-3.84-.68-.92-.33-.92-.33a10.32 10.32 0 015.58.62s4.12-1.54 4.04-1.8z"
        transform="translate(-33.54 -30.43)"
      />
      <ellipse
        cx="1056.06"
        cy="720.01"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="16.87"
        ry="2.85"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M965.32 743.93s-28.78-1.74-25.38 18.43a4.91 4.91 0 002.55 5.18s0-1.5 3-1a13.14 13.14 0 003.13.15 6.46 6.46 0 003.82-1.58s8.09-3.34 11.24-16.56c0 0 2.33-2.88 2.23-3.63L961 747s1.66 3.5.35 6.41c0 0-.16-6.28-1.09-6.14-.19 0-2.52 1.22-2.52 1.22s2.85 6.1.7 10.54c0 0 .82-7.52-1.59-10.1l-3.42 2s3.33 6.31 1.07 11.45c0 0 .58-7.89-1.79-11l-3.1 2.42s3.14 6.21 1.22 10.48c0 0-.24-9.19-1.89-9.88 0 0-2.71 2.39-3.12 3.37 0 0 2.14 4.51.81 6.89 0 0-.82-6.12-1.49-6.15 0 0-2.69 4.06-3 6.83a14.77 14.77 0 012.33-7.22 8.1 8.1 0 00-4.13 2.15s.42-2.87 4.8-3.12c0 0 2.23-3.08 2.83-3.26 0 0-4.36-.37-7 .8 0 0 2.32-2.7 7.79-1.47l3.06-2.5s-5.73-.78-8.17.08c0 0 2.8-2.39 9-.64l3.33-2s-4.89-1.05-7.81-.67c0 0 3.08-1.66 8.78.14l2.38-1.07s-3.58-.7-4.63-.81-1.1-.4-1.1-.4a12.36 12.36 0 016.73.74s5.08-1.85 4.99-2.16z"
        transform="translate(-33.54 -30.43)"
      />
      <ellipse
        cx="911.96"
        cy="738.87"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="20.37"
        ry="3.44"
      />
      <ellipse
        cx="54.65"
        cy="819"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="29.92"
        ry="5.06"
      />
      <path
        fill="#a8a8a8"
        d="M68.1 825.92s17.06-.52 22.21-4.18 26.25-8 27.53-2.17 25.65 29.22 6.38 29.38-44.77-3-49.91-6.13-6.21-16.9-6.21-16.9z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M124.56 846.9c-19.27.16-44.77-3-49.91-6.13-3.9-2.38-5.46-10.93-6-14.87h-.57s1.08 13.77 6.21 16.9 30.71 6.3 49.93 6.2c5.56-.05 7.48-2 7.38-5-.78 1.76-2.9 2.87-7.04 2.9z"
        opacity="0.2"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="url(#g)"
        d="M909.52 6.09H1080.19V311.51H909.52z"
        transform="rotate(-71.99 957.142 166.666)"
      />
      <path
        fill="#f6f7f9"
        d="M910.69 8.2H1079.01V309.4H910.69z"
        transform="rotate(-71.99 957.142 166.666)"
      />
      <circle
        cx="874.94"
        cy="90.37"
        r="31.36"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.2"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1045.5 63.87H1054.09V200.5H1045.5z"
        opacity="0.2"
        transform="rotate(-71.99 1012.09 140.051)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1006.86 107.86H1015.45V177.45999999999998H1006.86z"
        opacity="0.2"
        transform="rotate(-71.99 973.44 150.525)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1020.51 113.85H1029.1V226.42H1020.51z"
        opacity="0.2"
        transform="rotate(-71.99 987.096 178.005)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1025.18 126.38H1033.77V263.01H1025.18z"
        opacity="0.2"
        transform="rotate(-71.99 991.761 202.56)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M1057.14 224.95H1073.75V262.76H1057.14z"
        opacity="0.5"
        transform="rotate(-71.99 1027.74 251.725)"
      />
      <path
        fill="url(#h)"
        d="M968.51 513.39a9.14 9.14 0 00-.1-1c0-.35-.11-.7-.17-1-.13-.68-.27-1.35-.43-2-.08-.31-.16-.63-.25-.93a25.36 25.36 0 00-5-9.67c-.13-.16-.27-.31-.4-.46s-.54-.58-.81-.85-.52-.51-.78-.74-.5-.44-.74-.64c-.48-.39-.93-.72-1.32-1s-.57-.38-.81-.52a4.44 4.44 0 00-1.88-.61l-4.15-.41L946 493l-20.27-7.87-.8.28a46 46 0 01-1.5-5 4.48 4.48 0 001.6-1.17 3.65 3.65 0 001.1-1.41c.51-1.18-.47-3.69-.27-5.13.32-2.31 1.52-4.54 2.5-6.63 2.08-4.49 3.6-9.36 3.35-14.29s-2.5-9.93-6.66-12.68c-2.15-1.43-4.68-2.19-6.92-3.49-1.74-1-3.27-2.34-4.93-3.48a28.34 28.34 0 00-27.92-2c-4.21 2.07-7.8 5.17-11.77 7.66s-8.65 4.4-13.3 3.66a3.25 3.25 0 00-.14.58l-.39-.05c-.8 2.18 1.16 4.34 3 5.83 3.43 2.83 7.32 5.65 11.79 5.75 1.73 0 3.56-.33 5.13.38a4.7 4.7 0 011 .6 22.28 22.28 0 007 22.21l-10.35-3.72s-.43.22-1.1.64l-14.36-9.56S833 453.67 825 469.93s34.67 7.87 34.67 7.87l9.13 5a8.31 8.31 0 001 5.48l24.89 15.38c-5 1.55-13.29 4-14.76 4-2.13 0-8 2.1-11.73 10.49s-17.07 49.32-28.8 56.14-42.66 52.47-42.66 52.47l.14.36c-.55.15-1.09.3-1.62.48a32.78 32.78 0 00-16.07 12.12 5.14 5.14 0 003.6 8.11c12.21 1.55 18.88-4.08 22.09-8.33.21-.27.4-.54.58-.81a4.27 4.27 0 003 .14l14.93-12.07s-11.68 11.5-4.83 22l-.52.73a166.91 166.91 0 00-25 54.42s-6.4 4.72-6.93 23.61-6.94 49.32-6.94 49.32-4.26 36.21-1.6 47.22c0 0 .31.44.88 1.11-.2.24-.42.5-.66.76-2.33 2.52-6.53 6-11.42 5-7.46-1.58-7.46 11.54 3.2 12.59 6.87.67 20.37 3.74 29.12 5.84a6.13 6.13 0 007.6-6.54c-.52-4.7-1.47-10.39-3.2-14.44-.11-.25-.22-.5-.33-.73.31-.3.63-.6.94-.92 0 0 0-23.09 3.74-29.38 0 0 10.13-47.75 9.59-59.82-.41-9.44 26.29-46.21 37.91-61.74l-.1-.59c3-4 4.86-6.4 4.86-6.4l8.99 57.2s4.27 12.59 9.6 19.41c0 0 22.93 43.55 25.6 57.19 2 10.35 6.18 16.46 8.08 18.82l-.69.66c-2.43 2.23-6 4.46-10.06 3.61-7.46-1.58-7.46 11.54 3.2 12.59 6.87.68 20.37 3.75 29.11 5.85a6.14 6.14 0 007.61-6.55c-.61-5.46-1.8-12.25-4.1-16.26a11.25 11.25 0 00-.61-1 5.62 5.62 0 002.12-1.49s-13.87-33.06-13.87-42c0 0-5.86-34.1-25.59-46.69 0 0 1.86-42.66 7.48-66.4.14-.58.28-1.16.42-1.72a158.22 158.22 0 0015.56-3.24l.53-15.74 2.67 12.59 29.86-18.36s-.26-3.31-.76-8.38c-.26-2.54-.57-5.52-.94-8.75-.3-2.58-.64-5.32-1-8.12-.1-.7-.19-1.41-.29-2.11-.39-2.83-.82-5.69-1.28-8.49q-.27-1.58-.54-3.12c-.25-1.37-.5-2.71-.76-4-.13-.65-.27-1.3-.4-1.93s-.28-1.26-.42-1.87-.28-1.2-.42-1.79c-.08-.29-.15-.58-.22-.86-.15-.57-.3-1.13-.45-1.67a30 30 0 01-1.08-6.88v-2.77c0-.92.14-1.84.27-2.76.06-.45.14-.91.23-1.36a30.53 30.53 0 011.51-5.36c.33-.87.71-1.73 1.12-2.58 1-2 2-4.13 3.06-6.4.54-1.13 1.08-2.29 1.62-3.47s1.09-2.38 1.64-3.6c5.19-11.57 10.31-24.46 11.68-32.93.14-.89.25-1.73.3-2.52a16.08 16.08 0 00.03-2.16z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ae6e79"
        d="M879.44 482l-17.59-11.89s-27.93-10.35-35.69 5.69 33.62 7.76 33.62 7.76l17.59 9.82z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f9fafb"
        d="M759.18 443.97H927.66V706.25H759.18z"
        transform="rotate(-57.3 804.271 592.613)"
      />
      <path
        fill="#b7b6cc"
        d="M714.92 548.06H762.52V559.26H714.92z"
        transform="rotate(-57.57 694.298 568.97)"
      />
      <path
        fill="#b7b6cc"
        d="M731.54 532.39H836.0799999999999V542.66H731.54z"
        transform="rotate(-57.57 739.384 552.83)"
      />
      <path
        fill="#b7b6cc"
        d="M750.06 544.15H854.5999999999999V554.42H750.06z"
        transform="rotate(-57.57 757.898 564.59)"
      />
      <path
        fill="#b7b6cc"
        d="M768.57 555.91H873.11V566.18H768.57z"
        transform="rotate(-57.57 776.421 576.355)"
      />
      <path
        fill="#b7b6cc"
        d="M787.09 567.67H891.63V577.9399999999999H787.09z"
        transform="rotate(-57.3 800.185 590.292)"
      />
      <path
        fill="#fff"
        d="M805.6 579.44H910.14V589.71H805.6z"
        transform="rotate(-57.57 813.444 599.883)"
      />
      <path
        fill="#fff"
        d="M824.12 591.2H928.66V601.47H824.12z"
        transform="rotate(-57.57 831.959 611.642)"
      />
      <path
        fill="#b7b6cc"
        d="M926.91 569.86H953.98V596.9300000000001H926.91z"
        transform="rotate(-57.57 896.03 598.707)"
      />
      <path
        fill="#bebed0"
        d="M931.47 844.64c-8.49-2.07-21.58-5.09-28.24-5.76-10.35-1-10.35-14-3.1-12.42 3.92.85 7.4-1.36 9.75-3.55a22.84 22.84 0 002-2.19 6 6 0 013.35-2.05c3.88-.84 12-2.12 16.91.55a7.31 7.31 0 012.68 2.94c2.23 4 3.39 10.65 4 16a6 6 0 01-7.35 6.48zM800.6 849.81c-8.48-2.07-21.57-5.09-28.23-5.76-10.35-1-10.35-14-3.11-12.41 4.74 1 8.82-2.41 11.07-4.89.28-.3.53-.59.74-.86a6 6 0 013.34-2c3.88-.85 12-2.13 16.92.55 1.46.78 2.62 2.5 3.55 4.73 1.67 4 2.59 9.6 3.1 14.23a6 6 0 01-7.38 6.41z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M804.88 829.13c-12.35 12.73-22.94-.24-24.55-2.38.28-.3.53-.59.74-.86a6 6 0 013.34-2c3.88-.85 12-2.13 16.92.55 1.46.74 2.67 2.46 3.55 4.69zM934.87 822.16c-5.35 3.65-23.36 2.75-23.36 2.75a16.9 16.9 0 01-1.63-2 22.84 22.84 0 002-2.19 6 6 0 013.35-2.05c3.88-.84 12-2.12 16.91.55a7.31 7.31 0 012.73 2.94z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#5c5c8e"
        d="M935.82 819.74c-3.63 4.66-24.31 3.62-24.31 3.62s-6.21-6.21-8.8-19.65-24.83-56.38-24.83-56.38c-5.17-6.73-9.31-19.14-9.31-19.14l-8.79-56.38s-42.41 55.86-41.89 67.76-9.32 59-9.32 59c-3.62 6.21-3.62 29-3.62 29-13.44 14-24.82-2.59-24.82-2.59-2.59-10.86 1.55-46.55 1.55-46.55s6.21-30 6.72-48.62 6.73-23.27 6.73-23.27a165.87 165.87 0 0124.29-53.66c3.12-4.47 5.19-6.86 5.19-6.86l83.79 9.83a52.76 52.76 0 00-3.6 11.1c-5.45 23.4-7.26 65.45-7.26 65.45 19.14 12.41 24.83 46 24.83 46 0 8.75 13.45 41.34 13.45 41.34z"
        transform="translate(-33.54 -30.43)"
      />
      <g opacity="0.05">
        <path
          d="M855.17 678.7l-1.08-6.89s-42.41 55.86-41.89 67.76-9.31 59-9.31 59c-3.63 6.21-3.63 29-3.63 29a17.68 17.68 0 01-8.09 5.19c4.07 1.07 9 .28 14.3-5.19 0 0 0-22.76 3.62-29 0 0 9.83-47.07 9.31-59-.4-9.31 25.49-45.57 36.77-60.87z"
          transform="translate(-33.54 -30.43)"
        />
        <path
          d="M922.88 778.36s-5.69-33.62-24.82-46c0 0 1.81-42.05 7.25-65.45a52.71 52.71 0 013.61-11.1L825.13 646s-.2.22-.56.66l78.14 9.17a52.76 52.76 0 00-3.6 11.1c-5.45 23.4-7.26 65.45-7.26 65.45 19.14 12.41 24.83 46 24.83 46 0 8.79 13.45 41.38 13.45 41.38-2.14 2.74-10.2 3.51-16.47 3.68 5 .13 19.67.18 22.67-3.68 0-.02-13.45-32.61-13.45-41.4z"
          transform="translate(-33.54 -30.43)"
        />
      </g>
      <path
        fill="#ae6e79"
        d="M809.09 638.71a18.9 18.9 0 01-2.45 4.28c-3.11 4.19-9.58 9.73-21.42 8.21a5.09 5.09 0 01-3.5-8 31.87 31.87 0 0115.59-12 28.46 28.46 0 016.61-1.34z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#42383c"
        d="M918.33 494.05l-41.48-15.17s-11.9 6.21-7.24 15L910 519.23z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M918.49 494.22L877 479.05s-11.9 6.2-7.24 15l40.34 25.34z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ae6e79"
        d="M919.78 469.05s-.52 24.31 10.35 32.59-31.56 12.93-31.56 12.93 6.73-24.83 0-37.76 21.21-7.76 21.21-7.76z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M908.4 655.78a52.76 52.76 0 00-3.6 11.1c-50 7.64-84.85-13.17-84.85-13.17-.19-.3-.37-.6-.53-.9 3.12-4.47 5.19-6.86 5.19-6.86zM809.09 638.71a18.9 18.9 0 01-2.45 4.28c-4.79-.8-8.62-10-9.33-11.74a28.46 28.46 0 016.61-1.34z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#42383c"
        d="M923.92 490.78l-18.62 6.72-7.76 10.35s-16 5.17-18.1 5.17-7.76 2.07-11.38 10.34-16.55 48.64-27.93 55.35-41.38 51.72-41.38 51.72 5.17 14 11.38 11.9l14.48-11.9s-11.38 11.38-4.66 21.73c0 0 42.42 25.34 100.87 9.82l.51-15.51 2.59 12.41 29-18.1s-2.59-33.39-7.26-50.38a30.72 30.72 0 012-21.41c7.51-15.65 19.1-41.79 17.69-51.32-1.67-11.23-8-16.11-10.44-17.58a4.32 4.32 0 00-1.82-.61l-9.47-.94z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M892.11 542.76s-10.35 48.1-21.73 55.86-41.89 32.59-42.93 36.73"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#42383c"
        d="M887.45 541.21s-10.34 48.1-21.72 55.86-41.9 32.59-42.93 36.72"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M897.28 507.59s35.69-11.9 46-8.8"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <g opacity="0.05">
        <path
          d="M947.61 569c7.51-15.65 19.1-41.79 17.69-51.32-1.67-11.23-8-16.11-10.44-17.58a4.32 4.32 0 00-1.82-.61l-4-.4a4 4 0 011.2.49c2.42 1.48 8.77 6.35 10.43 17.59 1.41 9.52-10.18 35.67-17.68 51.32a30.7 30.7 0 00-2 21.4c4.68 17 7.27 50.38 7.27 50.38l-24.94 15.59.63 3 29-18.1s-2.59-33.39-7.26-50.38a30.72 30.72 0 011.92-21.38z"
          transform="translate(-33.54 -30.43)"
        />
        <path d="M905.38 467.59L909.86 468.04 890.38 460.35 888.63 460.98 905.38 467.59z" />
      </g>
      <path
        d="M887.45 591.38s16-8.79 21.21-6.72 24.31-.52 24.31-.52M918 475.52c-.59-5.19 1.81-4.4 1.81-4.4s-27.93-5.17-21.21 7.76a29.62 29.62 0 012.84 11.37h.27c7.76.01 12.29-8.67 16.29-14.73z"
        opacity="0.05"
        transform="translate(-33.54 -30.43)"
      />
      <circle
        cx="868.14"
        cy="435.52"
        r="22.24"
        fill="#ae6e79"
      />
      <path
        d="M926 472.53c2-4.43 3.49-9.23 3.25-14.09s-2.42-9.79-6.46-12.51c-2.08-1.4-4.54-2.15-6.71-3.43-1.69-1-3.18-2.31-4.79-3.43a27.11 27.11 0 00-27.08-2c-4.08 2-7.56 5.11-11.41 7.56s-8.39 4.33-12.9 3.61c-.78 2.15 1.13 4.27 2.88 5.75 3.33 2.79 7.1 5.57 11.44 5.66 1.68 0 3.45-.32 5 .38a7.17 7.17 0 012.54 2.36 46.58 46.58 0 015.28 8.95 7.42 7.42 0 002.36 3.48c2 1.28 4.59.21 7 .12 3.68-.15 7 2.17 9.72 4.65s5.32 5.32 8.76 6.63c2.57 1 7.71.94 9-2.13.49-1.16-.46-3.64-.26-5.06a24.48 24.48 0 012.38-6.5z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#42383c"
        d="M926.46 472c2-4.43 3.5-9.23 3.25-14.08s-2.41-9.8-6.45-12.51c-2.09-1.41-4.55-2.16-6.71-3.44-1.69-1-3.18-2.3-4.79-3.43a27.11 27.11 0 00-27.08-2c-4.08 2-7.56 5.1-11.41 7.55s-8.39 4.34-12.9 3.61c-.78 2.16 1.12 4.28 2.88 5.75 3.33 2.79 7.1 5.57 11.44 5.67 1.68 0 3.45-.33 5 .38a7 7 0 012.54 2.36 46 46 0 015.27 8.94 7.44 7.44 0 002.37 3.48c2 1.28 4.59.21 7 .12 3.68-.14 7 2.18 9.71 4.66s5.32 5.31 8.77 6.62c2.57 1 7.71.94 9-2.13.5-1.16-.45-3.64-.25-5.06a24.46 24.46 0 012.36-6.49z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M765.46 800.43a10.31 10.31 0 01-6.62 2.34l-446.77-1.9A13.75 13.75 0 01309 790.4l44.14-361.17 27.68-.3a10.46 10.46 0 0110.2 7.72l5.17 19.08a10.46 10.46 0 0010.34 7.72L517 460.8a10.46 10.46 0 0010.21-10.46V437.7a10.46 10.46 0 0110.34-10.46l153.08-1.65a10.46 10.46 0 0110.37 8.49l67.7 354 .44 2.28a10.4 10.4 0 01-3.68 10.07z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#e6e8ee"
        d="M685.63 430.6l-153.08 1.65a10.46 10.46 0 00-10.35 10.45v12.65A10.46 10.46 0 01512 465.8l-110.46 2.65a10.45 10.45 0 01-10.35-7.72L386 441.66a10.45 10.45 0 00-10.21-7.72l-147.55 1.59a10.45 10.45 0 00-10.2 12.2l59.36 349.36a10.46 10.46 0 0010.27 8.71l466.14 2a10.46 10.46 0 0010.31-12.42L696 439.09a10.45 10.45 0 00-10.37-8.49z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f6bac2"
        d="M901.22 191.36l-.8 8.9L901 216l-1.69 26.55s-.24 11.63-6.81 17.08l-16.77 25.75-.1.05-6.31 3.08-9.63 1-5-12.11 3.31-13.3 1.84-2.48.51-.56c2-2.2 9.72-10.19 15.85-12.68 0 0 4.09-3 3.37-7.7s5.52-29.68 5.52-29.68 4-16.52 3.13-18.13-.16-38.18 13.64-38.74-.64 37.23-.64 37.23z"
        transform="translate(-33.54 -30.43)"
      />
      <ellipse
        cx="151.43"
        cy="700.88"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="16.21"
        ry="2.23"
      />
      <ellipse
        cx="89.34"
        cy="707.17"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="16.21"
        ry="2.23"
      />
      <ellipse
        cx="16.21"
        cy="698.65"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="16.21"
        ry="2.23"
      />
      <ellipse
        cx="114.19"
        cy="725.1"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="11.52"
        ry="1.58"
      />
      <ellipse
        cx="49.75"
        cy="723.52"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
        rx="11.52"
        ry="1.58"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M122.53 737.11s22.73-74.52-3.56-104.37c-19.67-22.33-42-19.66-52-16.9a18.49 18.49 0 00-11.92 9.91c-3.5 7.54-2.87 19.78 21.81 34.07 41.31 23.92 43.88 56.73 43.88 56.73z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M70.54 626.41s67 21 52 110.7M109.68 633.92s-9.23 6.22-6.29 15.57M77.26 639.46s5.64-5.74 12.51-2.57M103.75 668.32s9.91-5 12.47 1.27M128.26 678.79s-7.44-.59-7.57 3"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M123.45 737.7s-26.63-54.16-33.94-53c-3.47.57-5.07 4-5.8 7.42a21.79 21.79 0 001.45 13.18c3.78 8.7 13.93 25.15 38.29 32.4z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M89.71 695s27.94 40.52 33.34 42.3"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M53.6 670.9L60.12 670.9"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M61.41 685.72L71.64 686.16"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M67.64 673.86L66.53 679.19"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M78.51 690.07L78.31 694.91"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M122.66 737.7s26.62-54.16 33.93-53c3.48.57 5.08 4 5.8 7.42a21.79 21.79 0 01-1.45 13.18c-3.78 8.7-13.94 25.15-38.28 32.4z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M156.4 695s-28 40.52-33.35 42.3"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M125.43 670.9L118.91 670.9"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M117.62 685.72L107.39 686.16"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M111.39 673.86L112.5 679.19"
      />
      <path
        fill="none"
        stroke="#565987"
        strokeMiterlimit="10"
        d="M100.52 690.07L100.72 694.91"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M76.94 750.35a4.6 4.6 0 01-1.51-2.29 2 2 0 011.06-2.33c1-.37 2 .3 2.8 1S81 748.17 82 748a4.14 4.14 0 01-1.28-3.88 1.58 1.58 0 01.35-.79c.54-.58 1.52-.33 2.17.13 2 1.44 2.63 4.23 2.64 6.75a12.9 12.9 0 000-2.78A2.85 2.85 0 0187 745a3.12 3.12 0 011.59-.38 3.3 3.3 0 012.59.74 2.57 2.57 0 01-.1 3.17 10.2 10.2 0 01-2.68 2.14 6 6 0 00-1.91 1.83 1.34 1.34 0 00-.14.32h-5.82a16.14 16.14 0 01-3.59-2.47zM178.39 728.53a4.53 4.53 0 01-1.51-2.28 2 2 0 011.05-2.33c1-.37 2 .3 2.8 1s1.7 1.46 2.73 1.31a4.14 4.14 0 01-1.29-3.87 1.59 1.59 0 01.36-.79c.54-.58 1.52-.33 2.17.12 2.05 1.45 2.63 4.24 2.64 6.76a13 13 0 000-2.79 2.86 2.86 0 011-2.46 3.19 3.19 0 011.59-.37 3.34 3.34 0 012.59.73 2.57 2.57 0 01-.11 3.18 10 10 0 01-2.67 2.14 5.94 5.94 0 00-1.91 1.82 1.64 1.64 0 00-.14.33H182a16 16 0 01-3.61-2.5zM144.58 750.35a4.69 4.69 0 01-1.52-2.29 2 2 0 011.06-2.33c1-.37 2 .3 2.8 1s1.69 1.46 2.73 1.32a4.17 4.17 0 01-1.29-3.88 1.59 1.59 0 01.36-.79c.54-.58 1.52-.33 2.17.13 2.05 1.44 2.62 4.23 2.64 6.75a12.91 12.91 0 000-2.78 2.86 2.86 0 011.05-2.46 3.09 3.09 0 011.59-.38 3.31 3.31 0 012.59.74 2.56 2.56 0 01-.11 3.17 10.15 10.15 0 01-2.67 2.14 6 6 0 00-1.91 1.83 1.34 1.34 0 00-.14.32h-5.8a16.31 16.31 0 01-3.55-2.49zM48.69 706.25s-2.17 2.84 1 7.13 5.79 7.91 4.73 10.58c0 0-4.79-8-8.69-8.07s-1.33-4.89 2.96-9.64z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M48.69 706.25a3.58 3.58 0 00-.44.89c-3.8 4.47-5.83 8.64-2.17 8.75 3.4.1 7.49 6.18 8.46 7.72a3.58 3.58 0 01-.11.35s-4.79-8-8.69-8.07-1.34-4.89 2.95-9.64z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ffd037"
        d="M44.66 709.87c0 1 .11 1.81.25 1.81s.25-.81.25-1.81-.14-.53-.28-.53-.22-.47-.22.53z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ffd037"
        d="M43.27 711.07c.88.48 1.64.76 1.71.64s-.59-.6-1.47-1.08-.53-.13-.6 0-.52-.04.36.44z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill={get(theme, 'palette.primary.light')}
        d="M60.16 706.25s2.18 2.84-1 7.13-5.79 7.91-4.73 10.58c0 0 4.79-8 8.69-8.07s1.33-4.89-2.96-9.64z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M60.16 706.25a3.79 3.79 0 01.45.89c3.8 4.47 5.83 8.64 2.17 8.75-3.4.1-7.49 6.18-8.47 7.72a2.06 2.06 0 00.12.35s4.79-8 8.69-8.07 1.33-4.89-2.96-9.64z"
        opacity="0.1"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ffd037"
        d="M64.2 709.87c0 1-.11 1.81-.25 1.81s-.25-.81-.25-1.81.14-.53.28-.53.22-.47.22.53z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#ffd037"
        d="M65.59 711.07c-.88.48-1.65.76-1.71.64s.59-.6 1.47-1.08.53-.13.59 0 .52-.04-.35.44z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#a8a8a8"
        d="M63.51 723.59s-6.07-.19-7.9-1.49-9.34-2.86-9.8-.77-9.12 10.4-2.27 10.45 15.93-1.07 17.76-2.18 2.21-6.01 2.21-6.01z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        d="M43.42 731.05c6.86.06 15.93-1.06 17.76-2.18 1.39-.84 1.94-3.88 2.13-5.29h.2s-.38 4.9-2.21 6-10.9 2.24-17.76 2.18c-2 0-2.66-.72-2.62-1.76.27.65 1.08 1 2.5 1.05z"
        opacity="0.2"
        transform="translate(-33.54 -30.43)"
      />
      <circle
        cx="33.94"
        cy="126.71"
        r="21.63"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
      />
      <circle
        cx="1074.03"
        cy="299.56"
        r="21.63"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
      />
      <circle
        cx="685.21"
        cy="58.02"
        r="21.63"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
      />
      <circle
        cx="77.2"
        cy="246.04"
        r="36.25"
        fill={get(theme, 'palette.primary.light')}
        opacity="0.1"
      />
      <path
        fill="#f6f7f9"
        d="M463.74 619.07l-1.28-1.28a1.37 1.37 0 010-2l11.23-11.24a1.37 1.37 0 012 0l11.23 11.23a1.39 1.39 0 010 2l-1.28 1.28a1.39 1.39 0 01-2 0l-6.64-7v16.61a1.38 1.38 0 01-1.38 1.39h-1.85a1.39 1.39 0 01-1.39-1.39v-16.59l-6.64 7a1.39 1.39 0 01-2-.01z"
        transform="translate(-33.54 -30.43)"
      />
      <path
        fill="#f6f7f9"
        d="M474.67 594.34a22.79 22.79 0 11-22.79 22.79 22.81 22.81 0 0122.79-22.79m0-3a25.79 25.79 0 1025.79 25.79 25.79 25.79 0 00-25.79-25.79z"
        transform="translate(-33.54 -30.43)"
      />
    </svg>
  );
};
